import React, { Component } from 'react';
import './CollectionsList.css';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import { routeCodes } from '../../../config/routes';

const ctaCollections = {
  Srpski: 'Saznaj više',
  English: 'Find more',
  Italian: 'Adelante',
}

class CollectionsList extends Component {

   scrollToTop() {
      window.scrollTo(0, 0);
  }

  render() {
    const { data, language } = this.props;
    return (
    	<div className='CollectionsList'>
        { data.map((collection, index) => {
          return (
            <NavLink key={ index } onClick={ () => this.scrollToTop() } to={{ pathname: routeCodes.COLLECTION, state: {'page': index} }}>
            <div style={{ backgroundImage: `url(${ collection.image })` }} className='CollectionsList-collection'>
              <h2 className='CollectionsList-collection-title'>{ collection.name[language] }</h2>
              <span className='CollectionsList-collection-button'>{ctaCollections[language]}</span>
            </div>
            </NavLink>
          )
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  }
}

export default withRouter(
  connect(mapStateToProps)(CollectionsList)
);


// WEBPACK FOOTER //
// ./src/components/Collections/CollectionsList/index.js